import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ILink } from '../../../../../data';
import * as $ from 'jquery';
import { FilterSpecification } from '../../../../../data/framework/searchObjects';
import { SpkSearchGridComponent } from '../spk-search-grid/spk-search-grid.component';

@Component({
  standalone: false,
  selector: 'spk-modal-lookup',
  templateUrl: './spk-modal-lookup.component.html',
  styleUrls: ['./spk-modal-lookup.component.scss']
})
export class SpkModalLookupComponent implements OnInit, AfterViewInit {

  @Input() id: string = "";
  @Input() list: string = "";
  @Input() title: string = "";
  @Input() sort: string = "";
  @Input() command: string = "";
  @Input() searchString: string = "";
  @Input() filter: FilterSpecification = new FilterSpecification();
  @Input() autoload: boolean = true;
  @Output() rowSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() closed: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('searchGrid') searchGrid: SpkSearchGridComponent;

  showing: boolean = false;

  public links: ILink[] = [];

  constructor() { }

  ngOnInit() {
    this.links.push({
      text: '', action: this.selectRow, icon: 'hand-pointer-o'
    });

  }

  ngAfterViewInit() {
    var that = this;
    $(`#${this.id}`).on('show.bs.modal', function (e) {
      setTimeout(() => {
        that.searchGrid.searchInput.input.nativeElement.focus();
      }, 600);
    });
    $(`#${this.id}`).on('hidden.bs.modal', function (e) {
      that.closed.emit(true);
      that.showing = false;
    });
  }

  show() {
    if (!this.showing) {
      this.showing = true;
      $(`#${this.id}`).modal('show');
    }
  }

  selectRow = (row: any) => {
    this.rowSelected.emit(row);
    $(`#${this.id}`).modal('hide');
  }

  public load() {
    this.searchGrid.load();
  }

  close() {
    this.closed.emit(true);
    this.showing = false;
    $(`#${this.id}`).modal('hide');
  }
}
